import Avatar from 'components/base/Avatar';
import React from 'react';
import { Card, CardBody } from 'react-bootstrap';
import UserIcon from 'assets/img/post/user-bg.png';
import Badge from 'components/base/Badge';
import Button from 'components/base/Button';
import { MenuItemProps, Props } from './aboutJob.type';
import LocationIcon from 'assets/img/view-post/location.svg';
import SalaryRangeIcon from 'assets/img/view-post/salary.svg';
import SkillIcon from 'assets/img/view-post/job.svg';
import { htmlDecode } from 'helpers/utils';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

const RelativeTime = ({ createdDate }: { createdDate: string }) => {
  return <span>{dayjs(createdDate).fromNow()}</span>;
};

const MenuItem = ({ icon, label, value }: MenuItemProps) => {
  return (
    <div className="d-flex gap-2 align-items-center">
      <img src={icon} width={24} />
      <p className="m-0 d-flex gap-1 align-items-center">
        <span className="fw-bold text-nowrap">{label} - </span>
        <div>{value}</div>
      </p>
    </div>
  );
};

function AboutJob({ data, onApply, onSave }: Props) {
  const salaryRange =
    data?.isBillable && Array.isArray(data?.salaryRange)
      ? `INR ${data.salaryRange[0]} / INR ${data.salaryRange[1]}`
      : '';
  return (
    <Card>
      <CardBody>
        <header className="d-flex mb-3">
          <div className="d-flex align-items-center gap-3 me-4">
            <Avatar src={UserIcon} size="xl" rounded="soft" />
            <h4>{data?.companyName}</h4>
          </div>
          <div className="vr bg-light"></div>
          <div className="ms-4 d-flex gap-2 align-items-center">
            {data?.modeOfWork && <Badge variant="tag">{data.modeOfWork}</Badge>}
            <Badge variant="tag">{data?.employmentType}</Badge>
          </div>
        </header>
        <p className="mb-0">
          <span className="fs-5 fw-bold ">{data?.title}</span>
          <sup className="ms-2">{data?.role?.value}</sup>
        </p>
        <p className="mb-3">
          {data?.jobLocation} ·{' '}
          {data && data.createdAt && (
            <span>
              Reposted <RelativeTime createdDate={data.createdAt} /> ·{' '}
            </span>
          )}
          {data &&
            Array.isArray(data.candidates) &&
            data.candidates.length > 0 && (
              <span>Over {data.candidates.length} people clicked apply ·</span>
            )}
        </p>
        {(typeof onApply === 'function' || typeof onSave === 'function') && (
          <div className="mb-3">
            {typeof onApply === 'function' && (
              <Button variant="primary" className="me-3">
                Apply
              </Button>
            )}
            {typeof onSave === 'function' && (
              <Button variant="outline-primary" className="me-3">
                Save
              </Button>
            )}
          </div>
        )}

        <div className="mb-6">
          <h5 className="mb-3">About the job</h5>
          <div className="d-flex gap-3 mb-3 flex-wrap">
            <MenuItem
              icon={LocationIcon}
              label="Location"
              value={data?.jobLocation}
            />
            <MenuItem
              icon={SalaryRangeIcon}
              label="Salary range"
              value={salaryRange}
            />

            <MenuItem
              icon={SalaryRangeIcon}
              label="Eduction"
              value={data?.qualification}
            />
            {data?.experience && (
              <MenuItem
                icon={SalaryRangeIcon}
                label="Experience"
                value={data.experience}
              />
            )}
          </div>

          {data && Array.isArray(data.skills) && (
            <MenuItem
              icon={SkillIcon}
              label="Key Skill"
              value={
                <div className="d-flex gap-2 align-items-center flex-wrap">
                  {data.skills.map(({ name }, idx) => (
                    <Badge key={idx} variant="tag">
                      {name}
                    </Badge>
                  ))}
                </div>
              }
            />
          )}
        </div>
        {data && data.desc && (
          <div dangerouslySetInnerHTML={{ __html: htmlDecode(data.desc) }} />
        )}
      </CardBody>
    </Card>
  );
}

export default AboutJob;
